import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getJournal } from "@/lib/api";
import { Overline } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";
import { Reveal } from "@/lib/reveal";

export default function Journal() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { getJournal().then(setArticles).catch(() => {}); }, []);
  const [feature, ...rest] = articles;

  return (
    <div data-testid="journal-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12 text-center">
        <Overline>Letters, thoughts & seasonal notes</Overline>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light mt-5 leading-none">The Journal</h1>
      </section>

      {feature && (
        <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20">
          <Reveal>
            <Link to={`/journal/${feature.slug}`} data-testid={`journal-feature-${feature.slug}`} className="group grid lg:grid-cols-2 gap-12 items-center">
              <div className="overflow-hidden"><img src={feature.cover} alt={feature.title} className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700" /></div>
              <div>
                <span className="overline text-[0.62rem]">{feature.category} · {feature.read_time}</span>
                <h2 className="text-4xl sm:text-5xl font-light mt-4 mb-5 leading-tight group-hover:text-brand-olive transition-colors">{feature.title}</h2>
                <p className="font-body text-brand-body text-lg leading-relaxed">{feature.excerpt}</p>
                <span className="link-underline inline-block mt-6 font-sans text-xs uppercase tracking-[0.16em]">Continue reading</span>
              </div>
            </Link>
          </Reveal>
        </section>
      )}

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-3 gap-x-10 gap-y-16">
          {rest.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.08}>
              <Link to={`/journal/${a.slug}`} data-testid={`journal-card-${a.slug}`} className="group block">
                <div className="overflow-hidden"><img src={a.cover} alt={a.title} className="w-full aspect-[3/2] object-cover group-hover:scale-105 transition-transform duration-700" /></div>
                <span className="overline text-[0.62rem] mt-5 block">{a.category} · {a.read_time}</span>
                <h3 className="font-serif text-2xl mt-2 group-hover:text-brand-olive transition-colors leading-snug">{a.title}</h3>
                <p className="font-body text-brand-muted mt-2 leading-relaxed">{a.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <NewsletterSection />
    </div>
  );
}
